import { deleteRequest } from '../clients/axios';

export const deleteMyPlayer = async (playerId: number) => {
  const url = `appuser/myPlayer/${playerId}`;
  const response = await deleteRequest(url);
  return response;
};
